export const defaultState = {
  showing: false,
  notification: {},
};

export const SHOW_TOAST = 'SHOW_TOAST';
export const showToast = (notification) => {
  return dispatch => {
    return dispatch({
      type: SHOW_TOAST,
      payload: {
        showing: true,
        notification,
      },
    });
  };
};

const DEFAULT_ERROR_TIMEOUT = 5000;
const DEFAULT_SUCCESS_TIMEOUT = 3000;

export const toastFailure = (message, title, dismissAfter) => showToast({
  state: 'ERROR',
  title: title ?? 'Error',
  message,
  dismissible: true,
  dismissAfter: dismissAfter ?? DEFAULT_ERROR_TIMEOUT,
});

export const toastSuccess = (message, title, dismissAfter) => showToast({
  state: 'SUCCESS',
  title: title ?? 'Success',
  message,
  dismissible: true,
  dismissAfter: dismissAfter ?? DEFAULT_SUCCESS_TIMEOUT,
});

export const HIDE_TOAST = 'HIDE_TOAST';
export const hideToast = () => {
  return {
    type: HIDE_TOAST,
    payload: {
      showing: false,
      notification: {},
    },
  };
};

export const actions = {
  hideToast,
  showToast,
};

export default function reducer(state = defaultState, action = {}) {
  switch (action.type) {
    case HIDE_TOAST:
    case SHOW_TOAST:
      return {
        ...state,
        notification: action.payload.notification,
        showing: action.payload.showing,
      };
    default:
      return state;
  }
}
